import * as React from "react";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { LoBBadgeProps } from "components/flexComponents/Packages/typings";

const LobBadge: React.FC<LoBBadgeProps> = ({ packageType }: { packageType: any }) => {
  const iconSize = UitkIconSize.EXTRA_SMALL;
  if (packageType === "fh") {
    return (
      <UitkLayoutFlex direction="row">
        <UitkIcon name="lob_hotels" size={iconSize} />
        <UitkIcon name="add" size={iconSize} />
        <UitkIcon name="lob_flights" size={iconSize} />
      </UitkLayoutFlex>
    );
  }

  return null;
};
export default LobBadge;
